export default "__VITE_ASSET__BXV7MnIe__"